<pre style="word-wrap: break-word; white-space: pre-wrap;color: #FFF;">
  <ng-container>
    {{firsttext}}
    {{sitemap}}
    @for (item of sitemapdata; track item) {
      {{secondtext}}
      {{thirdtext}}{{item}}{{fifthtext}}
      {{fouthtext}}
    }
    {{sixthtext}}
  </ng-container>
</pre>





